import React from 'react';
import './PartnersPage.css';

import { PageTitle, Heading } from '../../components';
import { partners, partnersDescription } from '../../constants';

import { Autoplay, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

// --- Lista partnerów tekstowych ---
const textPartners = [
    "Gmina Nowe Ostrowy",
    "Polskie Towarzystwo Różane",
    "SGGW wydział Ogrodniczy",
    "Instytut Ogrodnictwa Inhort",
    "UŁ wydział nauk o wychowaniu Instytut psychologii",
    "Ogólnopolskie Stowarzyszenie Twórców Ogrodów",
    "Polskie Stowarzyszenie Centrów Ogrodniczych",
    "Calmnest",
    "Zielona Przystań centrum ogrodnicze",
    "Towarzystwo Kolei Wąskotorowych w Krośniewicach ",
    "Hurtownia Ogrodnicza Bogdan Królik",
    "Polskie Towarzystwo Chirurgów Drzew-NOT",
    "Kutnowski Dom Kultury"
];

const mediaPatron = ["Biznes Ogrodniczy", "Radio Q 100,7 FM"];

const PartnersPage = () => {
    const aboutPartners = partnersDescription[0];
    const becomePartner = partnersDescription[1];

    return (
        <>
            <PageTitle title={'Partnerzy'} page={'Partnerzy'} />

            <section className='partners'>
                {/* --- Top Section: Description --- */}
                <Heading title={'Nasi partnerzy'} subTitle={'Cenieni Nasi'} />

                <div className='partners-description'>
                    <p className='text'>{aboutPartners.content}</p>
                    <p className='text-end'>{aboutPartners.end}</p>
                </div>

                {/* --- Middle Section: Slider --- */}
                <div className='client-slider'>
                    <Swiper
                        modules={[Autoplay, Navigation, Pagination]}
                        navigation={true}
                        pagination={{ clickable: true }}
                        spaceBetween={30}
                        loop={true}
                        autoplay={{ delay: 2000, disableOnInteraction: false }}
                        breakpoints={{
                            0: { slidesPerView: 2 },
                            450: { slidesPerView: 3 },
                            768: { slidesPerView: 4 },
                            1024: { slidesPerView: 5 },
                        }}
                        className="logo-swiper" 
                    >
                        {partners.map((client, index) => {
                            return (
                                <SwiperSlide className='client-item' key={index}>
                                    <a href={client.link} target="_blank" rel="noopener noreferrer">
                                        <img src={client.image} alt='Partner logo' />
                                    </a>
                                </SwiperSlide>
                            )
                        })}
                    </Swiper>
                </div>

                {/* --- SEKCJA: Lista partnerów tekstowych oraz medialnych --- */}
                <div className='partners-text-list-wrapper'>
                    
                    <div className='partners-grid'>
                        {textPartners.map((partner, index) => (
                            <div className='partner-list-item' key={index}>
                                <span className='partner-bullet'></span>
                                {partner}
                            </div>
                        ))}
                    </div>

                    {/* POPRAWKA: Patroni Medialni mapowani do oddzielnych okienek */}
                    <div className='media-patrons-container'>
                        {mediaPatron.map((patron, index) => (
                            <div className='media-patron-box' key={index}>
                                <span className='patron-label'>Patron medialny</span>
                                <h4 className='patron-name'>{patron}</h4>
                            </div>
                        ))}
                    </div>
                </div>

                {/* --- Bottom Section: Call to Action --- */}
                <div className='partners-add'>
                    <div className='content-box'>
                        <h3>{becomePartner.title}</h3>
                        <p className='text'>{becomePartner.content}</p>
                        <p className='text-end'>{becomePartner.end}</p>
                    </div>
                </div>

            </section>
        </>
    );
}

export default PartnersPage;